// Use a true undefined in case the `undefined` is overridden for some reason.
export const UNDEF = void 0;
